module.exports = __webpack_public_path__ + "static/media/TasteIcon.fa120565.jpg";